const Controls = ({ isMuted, isVideoOff, toggleMute, toggleVideo, endCall }) => {
  return (
    <div className="controls">
      <button className="control-button" onClick={toggleMute}>
        {isMuted ? 'Unmute' : 'Mute'}
      </button>
      <button className="control-button" onClick={toggleVideo}>
        {isVideoOff ? 'Video On' : 'Video Off'}
      </button>
      <button className="control-button end-call" onClick={endCall}>
        End Call
      </button>
    </div>
  );
};

export default Controls;
